/* LGC contact enquiry: no checkout, cart writes, personal-data storage or analytics. */
(() => {
  'use strict';
  const dialog = document.getElementById('LgcDepositDialog');
  if (!dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const summary = document.getElementById('LgcDepositSummary');
  let opener;
  const publicReference = sku => String(sku || '').replace(/^MPS(?=\d)/i, 'MGS').replace(/^OPS(?=\d)/i, 'OGS').replace(/^PS(?=\d)/i, 'GS');
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat('fr-FR', {style:'currency',currency}).format(cents / 100);
  const open = (button, text) => {
    opener = button;
    if (summary) summary.value = text;
    dialog.showModal();
    (summary || dialog.querySelector('button')).focus();
    if (summary) { summary.scrollTop = 0; summary.scrollLeft = 0; }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-lgc-deposit-product],[data-lgc-deposit-cart]');
    if (!button) return;
    const error = button.closest('.lgc-deposit-callout').querySelector('[data-lgc-deposit-error]');
    error.hidden = true;
    try {
      if (button.hasAttribute('data-lgc-deposit-product')) {
        const form = button.closest('form');
        if (!form || !form.reportValidity()) return;
        const data = new FormData(form);
        const variant = JSON.parse(button.dataset.productVariants).find(v => String(v.id) === String(data.get('id')));
        if (!variant || !variant.available) throw new Error('Cette configuration n’est pas disponible. Veuillez vérifier vos choix.');
        const properties = [...data.entries()].filter(([key]) => /^properties\[[^_]/.test(key));
        if (properties.some(([,value]) => !String(value).trim())) throw new Error('Veuillez compléter les finitions de votre configuration avant de continuer.');
        const finishes = properties.filter(([key]) => /Finition (du corps|extérieure|intérieure|du plateau)/.test(key)).map(([,value])=>value);
        if (finishes.length > 1 && new Set(finishes).size < 2) throw new Error('Double Color nécessite au moins deux finitions différentes.');
        const quantity = Number(data.get('quantity') || 1);
        if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Veuillez saisir une quantité valide.');
        const scope = form.closest('[data-section-type="product"]') || form.closest('.product-section') || form.closest('.shopify-section');
        const price = scope && scope.querySelector('[data-product-price]');
        if (!price || !price.textContent.trim()) throw new Error('Le prix affiché ne peut pas être récupéré. Veuillez réessayer.');
        const url = new URL(button.dataset.productUrl, location.origin);
        url.searchParams.set('variant', variant.id);
        const options = JSON.parse(button.dataset.productOptions);
        const lines = [button.dataset.productTitle, 'Référence publique : ' + (publicReference(variant.sku) || 'À vérifier par notre équipe'), 'URL : ' + url.href];
        variant.options.forEach((value,index) => { if (value !== 'Default Title') lines.push(options[index] + ' : ' + value); });
        properties.forEach(([key,value]) => lines.push(key.slice(11,-1) + ' : ' + value));
        lines.push('Quantité : ' + quantity, 'Prix unitaire affiché : ' + price.textContent.trim(), 'Total produits pour cette quantité : ' + money(variant.price * quantity), 'Livraison et montant final à confirmer par notre équipe.');
        open(button, lines.join('\n'));
      } else {
        button.disabled = true;
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error('Le panier ne peut pas être récupéré. Veuillez réessayer.');
        const cart = await response.json();
        if (!cart.items?.length) throw new Error('Votre panier est vide. Ajoutez un produit avant de nous transmettre votre demande.');
        const cartForm = button.closest('form');
        const quantities = cartForm ? [...cartForm.querySelectorAll('input[name="updates[]"]')] : [];
        if (quantities.length && quantities.some((field,index) => Number(field.value) !== cart.items[index]?.quantity)) throw new Error('La quantité est en cours de mise à jour. Patientez un instant puis réessayez.');
        const lines = [];
        cart.items.forEach((item,index) => {
          lines.push('Article ' + (index + 1) + ' : ' + item.product_title, 'Référence publique : ' + (publicReference(item.sku) || 'À vérifier par notre équipe'), 'URL : ' + new URL(item.url,location.origin).href);
          (item.options_with_values || []).forEach(option => {if (option.value !== 'Default Title') lines.push(option.name + ' : ' + option.value);});
          Object.entries(item.properties || {}).forEach(([key,value]) => {if (!key.startsWith('_') && value) lines.push(key + ' : ' + value);});
          lines.push('Quantité : ' + item.quantity, 'Prix unitaire du panier : ' + money(item.final_price,cart.currency), 'Total de la ligne : ' + money(item.final_line_price,cart.currency), '');
        });
        const note = cartForm?.querySelector('[name="note"]')?.value ?? cart.note;
        if (note) lines.push('Note du panier : ' + note);
        lines.push('Total produits affiché dans le panier : ' + money(cart.total_price,cart.currency), 'Livraison et montant final à confirmer par notre équipe.');
        open(button,lines.join('\n'));
      }
    } catch (issue) {
      error.textContent = issue.message || 'Une erreur est survenue. Veuillez réessayer.';
      error.hidden = false;
    } finally { button.disabled = false; }
  });
  dialog.querySelector('[data-lgc-deposit-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {if(opener?.isConnected) opener.focus();});
  const contact = document.getElementById('LgcDepositContact');
  contact.addEventListener('submit', event => {
    if (summary && !summary.value.trim()) {event.preventDefault(); summary.focus();}
  });
  if (dialog.querySelector('[data-lgc-deposit-result]') && location.hash === '#LgcDepositContact') dialog.showModal();
})();
